// config.js
// export const API_BASE_URL = "https://dev.dse-cc-api.com";
// export const API_BASE_URL = "https://live.dse-cc-api.com";
// export const FULL_API_BASE_URL = "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1";

// export const FULL_API_BASE_URL ="/coaching-collaborator-api/api/v1";

export const FULL_API_BASE_URL =
  "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1";
  // "https://live.dse-cc-api.com/coaching-collaborator-api/api/v1";
// "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/get-classes/";
// export const API_BASE_URL = "https://live.dse-cc-api.com";


// export const API_BASE_URL = "http://localhost:8000";
// export const FULL_API_BASE_URL = "http://localhost:8000/coaching-collaborator-api/api/v1";
// export const FULL_API_BASE_URL = "http://127.0.0.1:8000/coaching-collaborator-api/api/v1";